import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Helmet } from 'react-helmet';
import { Provider } from 'react-redux';
import { store, history } from 'modules/store';
import Routes from 'components/container/ConnectedRoutes';

const Root = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Helmet>
        {/* Disable indexing by default */}
        <meta name="robots" content="noindex" />
      </Helmet>
      <Routes />
    </ConnectedRouter>
  </Provider>
);
export default Root;
